module.exports = __webpack_public_path__ + "static/media/资源一号02D卫星.61dc2d49.png";